import { useAtom, useAtomValue } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'

import {
  customerAttributeIdsAtom,
  isPendingTabulationAtom,
  questionIdsAtom,
} from '../atoms'

export type TabulateButtonProps = {
  className?: string
}

export const TabulateButton = ({ className }: TabulateButtonProps) => {
  const { t } = useTranslation()
  const questionIds = useAtomValue(questionIdsAtom)
  const customerAttributeIds = useAtomValue(customerAttributeIdsAtom)
  const [isPendingTabulation, setIsPendingTabulation] = useAtom(
    isPendingTabulationAtom,
  )

  const handleClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    setIsPendingTabulation(false)
  }, [setIsPendingTabulation])

  if (
    (questionIds.length === 0 && customerAttributeIds.length === 0) ||
    !isPendingTabulation
  ) {
    return null
  }

  return (
    <StyledButton
      buttonStyle="alert"
      className={className}
      onClick={handleClick}
    >
      {t('refresh_results')}
    </StyledButton>
  )
}
